const vuetifyToastOptions = {
  x: 'center', // default
  y: 'top', // default
  color: 'info', // default
  icon: 'mdi-alert-circle',
  iconColor: '', // default
  classes: [
    'body-2'
  ],
  timeout: 5000, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: false, // default
  showClose: false, // default
  closeText: '', // default
  closeIcon: 'mdi-close', // default
  closeColor: '', // default
  slot: [], //default
  shorts: {
    custom: {
      color: 'primary'
    }
  },
  property: '$toast' // default
};

export default vuetifyToastOptions
